import ImageCropModal, { ImageCropModalProps } from './ImageCropModal';
import { ImageCropModalContentsProps } from './ImageCropModalContents';

export default ImageCropModal;
export type { ImageCropModalProps, ImageCropModalContentsProps };
